import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';
import type { BalanceItem } from '@/types/residents/lease';

export interface LeaseBalanceResponse {
  balanceDue: number;
  balanceItems: BalanceItem[];
}

export const leasesApi = createApi({
  reducerPath: 'leasesApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getLease: builder.query<
      any,
      { leaseId: number; includeTransactions: boolean; includePayments: boolean; includePending?: boolean }
    >({
      query: ({ leaseId, includeTransactions, includePayments, includePending = true }) => ({
        // Note: includeBalance removed - balance is fetched via dedicated endpoints
        // (Yardi: /api/v3/payments/yardi/sync-balance, Entrata: /api/v4/leases/:id/balance)
        url: `/api/v4/leases/${leaseId}?includeTransactions=${includeTransactions}&includePayments=${includePayments}&includePending=${includePending}`,
        method: 'GET',
      }),
    }),

    getLeaseEntrataDisabled: builder.query<any, { leaseId: number }>({
      query: ({ leaseId }) => ({
        url: `/api/v4/leases/entrata-disabled/${leaseId}`,
        method: 'GET',
      }),
    }),

    getLeaseBalance: builder.query<LeaseBalanceResponse, number>({
      query: (leaseId) => ({
        url: `/api/v4/leases/${leaseId}/balance`,
        method: 'GET',
      }),
      transformResponse: (resp: any) => resp?.response,
    }),
  }),
});

export const { useGetLeaseQuery, useLazyGetLeaseQuery, useGetLeaseEntrataDisabledQuery, useLazyGetLeaseEntrataDisabledQuery, useGetLeaseBalanceQuery } = leasesApi;


